module.exports = __webpack_public_path__ + "static/img/ic_arrow_right_primary.af0cbe2d.svg";